import { useMutation } from "react-query";
import { useSnackbar } from "notistack";

import { uploadFile } from "../../api/generic-api";
import { EmailPayload } from "../../models";

export const useSendInvoice = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(
    (payload: { invoiceId: string; emailPayload: EmailPayload }) =>
      uploadFile<EmailPayload>(
        `emails/invoice/${payload.invoiceId}`,
        payload.emailPayload
      ),
    {
      onSuccess: () => {
        enqueueSnackbar("Invoice Sent", { variant: "success" });
      },
      onError: () => {
        enqueueSnackbar("Invoice Send Error", { variant: "error" });
      },
    }
  );
};
